import { render } from "./CustomerGroupList.vue?vue&type=template&id=15f2c41a&ts=true"
import script from "./CustomerGroupList.vue?vue&type=script&lang=ts"
export * from "./CustomerGroupList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__